import { Grid } from "antd-mobile";
import CellTidy, { CellTidyDataType } from "components/item/cell-tidy";
import { useI18n } from "i18n/useI18n";
import { useNavigate } from "react-router-dom";
import { PostsDataType } from "services/apis/cnt2/post-api";

export type CellTidyListDataType = {
  column: number;
  cellTidyList?: CellTidyDataType[];
  tidyStatus: boolean;
  handleTidyStatus: any;
};

const CellTidyList: React.FC<CellTidyListDataType> = (props) => {
  const { t } = useI18n();
  const navigate = useNavigate();
  return (
    <>
      <Grid columns={props.column} gap={8}>
        {props.cellTidyList?.map((item, index) => {
          return (
            <div>
              <CellTidy
                key={index}
                {...item}
                showMask={props.tidyStatus}
                isRemove={item.isRemove}
                handleRemove={item.handleRemove}
              />
            </div>
          );
        })}
      </Grid>
    </>
  );
};

export default CellTidyList;
